var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4.364mm",
    height: "3.1623mm",
    viewBox: "0 0 4.364 3.1623",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath969"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m308.19 373.32c-0.602 0-1.16-0.32-1.464-0.84l-24.599-63.442c-0.464-1.195 1.239-2.08 1.892-0.976 6e-3 0.01 0.012 0.02 0.019 0.031l26.323 45.59c1.715 2.971 6.005 2.971 7.719 0l26.008-45.055c0.796-1.379 2.268-2.229 3.86-2.229h12.385l0.244 0.433-37.092 64.257c-0.798 1.38-2.271 2.231-3.865 2.231z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient981",
    x2: 1,
    gradientTransform: "matrix(54.569,-51.85,-51.85,-54.569,281.12,360.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4fcd9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c5d8a4",
    offset: 0.77737
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c5d8a4",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath991"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m329.59 373.32c-0.094 0-0.184-7e-3 -0.272-0.021-1.497-0.235-1.498-2.44-0.033-2.825l47.819-12.566c0.911-0.239 1.359-1.27 0.91-2.1l-4.101-7.602c-0.549-1.019-1.614-1.654-2.772-1.654h-23.582c-2.424 0-3.939-2.625-2.727-4.725l19.548-33.854c0.563-0.973 1.603-1.574 2.728-1.574h13.14l0.252 0.433-12.475 21.611c-1.212 2.1 0.304 4.724 2.728 4.724h7.677c1.125 0 2.166 0.601 2.728 1.575l13.887 24.044c0.563 0.974 0.563 2.176 0 3.151l-5.667 9.809c-0.564 0.973-1.603 1.574-2.728 1.574z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1005",
    x2: 1,
    gradientTransform: "matrix(36.282,-56.943,-56.943,-36.282,358.25,369.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4fcd9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c5d8a4",
    offset: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c5d8a4",
    offset: 0.56027
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c5d8a4",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-143.23 224.48)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35277 0 0 -.35277 -219.82 -106.72)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m308.19 373.32c-0.602 0-1.16-0.32-1.464-0.84l-24.599-63.442c-0.464-1.195 1.239-2.08 1.892-0.976 6e-3 0.01 0.012 0.02 0.019 0.031l26.323 45.59c1.715 2.971 6.005 2.971 7.719 0l26.008-45.055c0.796-1.379 2.268-2.229 3.86-2.229h12.385l0.244 0.433-37.092 64.257c-0.798 1.38-2.271 2.231-3.865 2.231z",
    fill: "url(#linearGradient981)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m329.59 373.32c-0.094 0-0.184-7e-3 -0.272-0.021-1.497-0.235-1.498-2.44-0.033-2.825l47.819-12.566c0.911-0.239 1.359-1.27 0.91-2.1l-4.101-7.602c-0.549-1.019-1.614-1.654-2.772-1.654h-23.582c-2.424 0-3.939-2.625-2.727-4.725l19.548-33.854c0.563-0.973 1.603-1.574 2.728-1.574h13.14l0.252 0.433-12.475 21.611c-1.212 2.1 0.304 4.724 2.728 4.724h7.677c1.125 0 2.166 0.601 2.728 1.575l13.887 24.044c0.563 0.974 0.563 2.176 0 3.151l-5.667 9.809c-0.564 0.973-1.603 1.574-2.728 1.574z",
    fill: "url(#linearGradient1005)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 .9935 .10547 2.1101)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1035.1,332.18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.969c1.285 0 2.336-1.091 2.336-2.424s-1.051-2.424-2.336-2.424h-5.005c-0.219 0-0.421-0.116-0.525-0.303l-1.206-2.168h-0.309c-0.45 0-0.737 0.462-0.526 0.845 0.463 0.841 0.936 1.705 1.392 2.524 0.104 0.186 0.305 0.302 0.524 0.302h5.655c0.647 0 1.18 0.553 1.18 1.224s-0.533 1.225-1.18 1.225h-2.316c-0.45 0-0.738-0.464-0.525-0.847l0.066-0.12c0.214-0.383-0.074-0.847-0.524-0.847-0.22 0-0.422 0.117-0.525 0.303l-0.681 1.225c-0.096 0.171-0.095 0.378 3e-3 0.549z",
    fill: "#a5def1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fef9e7"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1029.1,325.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 4.192 7.904c0.209 0.395 0.773 0.396 0.985 3e-3l0.025-0.048c0.089-0.165 0.089-0.363 0-0.528l-4.217-7.856c-0.098-0.182-0.286-0.294-0.492-0.294-0.421 0-0.69 0.447-0.493 0.819",
    fill: "#fef9e7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1036.6,326.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 0.879-1.637c0.094-0.176 0.277-0.285 0.477-0.285 0.41 0 0.671 0.437 0.477 0.798l-0.45 0.839c-0.095 0.175-0.278 0.285-0.477 0.285z",
    fill: "#fef9e7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,1038.8,329.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-0.172-0.14-0.312-0.312-0.312-0.173 0-0.313 0.14-0.313 0.312s0.14 0.312 0.313 0.312c0.172 0 0.312-0.14 0.312-0.312",
    fill: "#fef9e7"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d7f86d79a46e8915e4fd057c724796dd.svg";
export { ForwardRef as ReactComponent };